import { Modal, Button, Flex } from "antd"
import { WarningOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import styles from "./ProNewListingLayout.module.css"
import IconWithBg from "ui/IconWithBg"
import PropTypes from "prop-types"
import { spacings } from "themes/variables"

const ConnectPaymentProviderModal = ({ open, onCancel, onConnectStripe, onConnectPaypal, loading }) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable
      width={480}
      title={
        <div className="text-center">
          <IconWithBg className={styles.iconCircle} icon={<WarningOutlined style={{ color: "#faad14", fontSize: 32 }} />} />
        </div>
      }
    >
      <>
        <div className={styles.modalTitle}>{t("experiences.payment_provider.warning")}</div>
        <div className={styles.modalText}>
          {t("experiences.payment_provider.description_1")}
          <br />
          {t("experiences.payment_provider.description_2")}
        </div>
        <Flex gap={spacings.M}>
          <Button variant="outlined" color="primary" size="large" loading={loading} onClick={onConnectPaypal}>
            {t("experiences.payment_provider.paypal_button")}
          </Button>
          <Button type="primary" size="large" loading={loading} onClick={onConnectStripe}>
            {t("experiences.payment_provider.stripe_button")}
          </Button>
        </Flex>
      </>
    </Modal>
  )
}

ConnectPaymentProviderModal.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onConnectStripe: PropTypes.func,
  onConnectPaypal: PropTypes.func,
  loading: PropTypes.bool
}

export default ConnectPaymentProviderModal
